import { z } from 'zod/v3';

import { pointCouponItemSchema } from './coupons';

export const buyerPointSchema = z.object({
  /** 발급 가능한 포인트 쿠폰 목록 */
  issuableCoupons: z.array(pointCouponItemSchema),
  /** 보유 포인트 */
  totalPoint: z.number(),
});
export type BuyerPoint = z.infer<typeof buyerPointSchema>;
